// extracted by mini-css-extract-plugin
export var axis = "lab-mode-module--axis--6cb91";
export var axisContainer = "lab-mode-module--axisContainer--4edaa";
export var axisDescription = "lab-mode-module--axisDescription--ae202";
export var axisTitle = "lab-mode-module--axisTitle--c1693";
export var container = "lab-mode-module--container--22f38";
export var subtitle = "lab-mode-module--subtitle--0c8e8";
export var titleImage = "lab-mode-module--titleImage--fcd1d";
export var visuallyHidden = "lab-mode-module--visuallyHidden--0fe2a";